export function roundNumber(number: number, digits = 0): number {
  const base = Math.pow(10, digits)
  return Math.round(base * number) / base
}
